module.exports = __webpack_public_path__ + "img/tele2-slider-2_29c0b5ef8fd346423f598e3989992dc9.gif";


//////////////////
// WEBPACK FOOTER
// ./client/img/tele2-slider-2.gif
// module id = 257
// module chunks = 0